import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import Icon from '@/components/renewal/common/icon.vue';
import { useStore } from '@/store/useStore';
import { useAuth } from '@/plugins/auth';
import BookFilter from './book-filter.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'doctype-option',
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var availableBooks =
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- input-formからしか呼んでいない
    inject('availableBooks');
    var store = useStore();
    var auth = useAuth();
    var d1Option = auth.permissions.labsQAD1 || auth.user.labsWandhD1Option;
    var doctypes = ref([{
      name: '書籍',
      value: 'book'
    }, {
      name: '判例',
      value: 'case'
    }, {
      name: 'ガイドライン等',
      value: 'guideline'
    }]);
    var documentType = computed({
      get: function get() {
        return store.state.persistent.labs.wandh.inputQuery.filter.documentType;
      },
      set: function set(newVal) {
        store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
          filter: _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery.filter), {}, {
            documentType: newVal
          })
        }));
      }
    });
    onMounted(function () {
      var currentDocType = store.state.persistent.labs.wandh.inputQuery.filter.documentType;
      var unavailableTypes = store.state.persistent.labs.wandh.inputQuery.filter.unavailableDocumentTypes;
      if (unavailableTypes === undefined) {
        if (!d1Option && !currentDocType.includes('case')) {
          unavailableTypes = ['case'];
        } else {
          unavailableTypes = [];
        }
        store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
          filter: _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery.filter), {}, {
            unavailableDocumentTypes: unavailableTypes
          })
        }));
      } else {
        unavailableTypes = unavailableTypes || [];
      }
      if (d1Option) {
        if (unavailableTypes.includes('case') && !currentDocType.includes('case')) {
          var newDocumentType = [].concat(_toConsumableArray(currentDocType), ['case']);
          var newUnavailableTypes = unavailableTypes.filter(function (type) {
            return type !== 'case';
          });
          store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
            filter: _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery.filter), {}, {
              documentType: newDocumentType,
              unavailableDocumentTypes: newUnavailableTypes
            })
          }));
        } else if (unavailableTypes.includes('case') && currentDocType.includes('case')) {
          store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
            filter: _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery.filter), {}, {
              unavailableDocumentTypes: unavailableTypes.filter(function (type) {
                return type !== 'case';
              })
            })
          }));
        }
      } else {
        if (currentDocType.includes('case')) {
          var filteredDocumentType = currentDocType.filter(function (type) {
            return type !== 'case';
          });
          var _newUnavailableTypes = unavailableTypes.includes('case') ? unavailableTypes : [].concat(_toConsumableArray(unavailableTypes), ['case']);
          store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
            filter: _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery.filter), {}, {
              documentType: filteredDocumentType,
              unavailableDocumentTypes: _newUnavailableTypes
            })
          }));
        } else if (!unavailableTypes.includes('case')) {
          store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
            filter: _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery.filter), {}, {
              unavailableDocumentTypes: [].concat(_toConsumableArray(unavailableTypes), ['case'])
            })
          }));
        }
      }
    });
    watch(documentType, function (newVal, oldVal) {
      if (!oldVal.includes('book') && newVal.includes('book')) {
        store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
          filter: _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery.filter), {}, {
            id: {
              store: null,
              other: null
            }
          })
        }));
      }
      if (!d1Option && newVal.includes('case')) {
        newVal = newVal.filter(function (doctype) {
          return doctype !== 'case';
        });
        store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
          filter: _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery.filter), {}, {
            documentType: newVal
          })
        }));
      }
    });
    var isAllBooksSelected = computed(function () {
      return store.state.persistent.labs.wandh.inputQuery.filter.id.store === null && store.state.persistent.labs.wandh.inputQuery.filter.id.other === null;
    });
    var isSelectOnly = function isSelectOnly(type) {
      if (type === 'case' && !d1Option) {
        return true;
      }
      // lawは常に選択されているのでlengthが2のとき一つのドキュメントタイプしか選択されていないと判断できる
      return documentType.value.length === 2 && documentType.value.includes(type);
    };
    var isDocumentTypeValid = computed(function () {
      var _store$state$persiste, _store$state$persiste2;
      var filterId = [].concat(_toConsumableArray((_store$state$persiste = store.state.persistent.labs.wandh.inputQuery.filter.id.store) !== null && _store$state$persiste !== void 0 ? _store$state$persiste : availableBooks.value.store.map(function (book) {
        return book.naturalID;
      })), _toConsumableArray((_store$state$persiste2 = store.state.persistent.labs.wandh.inputQuery.filter.id.other) !== null && _store$state$persiste2 !== void 0 ? _store$state$persiste2 : availableBooks.value.other.map(function (book) {
        return book.naturalID;
      }))).sort();
      return (
        // 文献が選択されている。lawは常に選択されているのでlengthは1より常に大きくなければならない
        documentType.value.length > 1 && (
        // 書籍以外が選択されているか、書籍フィルターが空でない
        doctypes.value.filter(function (doctype) {
          return doctype.value !== 'book';
        }).some(function (doctype) {
          return documentType.value.includes(doctype.value);
        }) || !filterId || Array.isArray(filterId) && filterId.length > 0)
      );
    });
    expose({
      isDocumentTypeValid: isDocumentTypeValid
    });
    return {
      __sfc: true,
      availableBooks: availableBooks,
      store: store,
      auth: auth,
      d1Option: d1Option,
      doctypes: doctypes,
      documentType: documentType,
      isAllBooksSelected: isAllBooksSelected,
      isSelectOnly: isSelectOnly,
      isDocumentTypeValid: isDocumentTypeValid,
      Icon: Icon,
      BookFilter: BookFilter
    };
  }
});